export function getFieldExpressionFromDisplayTemplate(template: string): string {
  return template.replace(/{{/g, "").replace(/}}/g, "");
}

